// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".dialogMain[data-v-4cf4b143] {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n.dialogMain .rowEnd[data-v-4cf4b143] {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  margin-top: 20px;\n}\n.dialogMain .rowEnd .el-button[data-v-4cf4b143] {\n  width: 77px;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
